'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetPasswordValidator = exports.choosePasswordValidator = exports.changePasswordValidator = exports.thirdpartyLoginValidator = exports.loginValidator = undefined;
var _oneByOne = require('@marmalade/validation/lib/one-by-one');
var _oneByOne2 = _interopRequireDefault(_oneByOne);
var _required = require('@marmalade/validation/lib/required');
var _required2 = _interopRequireDefault(_required);
var _passwordStrength = require('@marmalade/validation/lib/password-strength');
var _passwordStrength2 = _interopRequireDefault(_passwordStrength);
var _sameAs = require('@marmalade/validation/lib/same-as');
var _sameAs2 = _interopRequireDefault(_sameAs);
var _looksLikeEmail = require('@marmalade/validation/lib/looks-like-email');
var _looksLikeEmail2 = _interopRequireDefault(_looksLikeEmail);
var _mxLookup = require('@marmalade/validation/lib/mx-lookup');
var _mxLookup2 = _interopRequireDefault(_mxLookup);
var _validDate = require('@marmalade/validation/lib/valid-date');
var _validDate2 = _interopRequireDefault(_validDate);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var newPasswordValidator = {
  newPassword: (0, _oneByOne2.default)((0, _required2.default)('Please enter your new password'), (0, _passwordStrength2.default)()),
  newPasswordConfirm: (0, _oneByOne2.default)((0, _required2.default)('Please enter your new password again'), (0, _sameAs2.default)('newPassword', 'The passwords do not match'))
};
var loginValidator = exports.loginValidator = {
  username: (0, _required2.default)('Please enter your username'),
  password: (0, _required2.default)('Please enter your password')
};
var thirdpartyLoginValidator = exports.thirdpartyLoginValidator = {
  firstName: (0, _required2.default)('Please enter their first name'),
  lastName: (0, _required2.default)('Please enter their last name'),
  dateOfBirth: (0, _validDate2.default)('Please enter their date of birth'),
  addressPostcode: (0, _required2.default)('Please enter their postcode')
};
var changePasswordValidator = exports.changePasswordValidator = Object.assign({
  password: (0, _required2.default)('Please enter your current password')
}, newPasswordValidator);
var choosePasswordValidator = exports.choosePasswordValidator = Object.assign({}, newPasswordValidator);
var resetPasswordValidator = exports.resetPasswordValidator = {
  email: (0, _oneByOne2.default)((0, _looksLikeEmail2.default)(), (0, _mxLookup2.default)())
};